import { useDebounceValue } from 'usehooks-ts'

import { useQueryLegacySearch } from '../../hooks/index.js'
import {
  ResultsView,
  SmartSearchEntityType,
  SmartSearchFilters,
} from '../../SmartSearch.types.js'

import { NoResults } from './NoResults.js'
import { SmartSearchResultsSection } from './SmartSearchResultsSection.js'

interface Props {
  filters: SmartSearchFilters
  setFilters: (filters: SmartSearchFilters) => void
  view: ResultsView
}
export const LegacySearchResults = ({ filters, setFilters, view }: Props) => {
  const { query, type, spaceIds } = filters
  const [debouncedQuery] = useDebounceValue(query, 500)

  const { posts, spaces, members, externals } = useQueryLegacySearch({
    query: debouncedQuery,
    type,
    spaceIds,
  })

  if (!query) {
    return null
  }

  const showNoResults =
    !posts.isLoading &&
    posts.data.length === 0 &&
    !spaces.isLoading &&
    spaces.data.length === 0 &&
    !members.isLoading &&
    members.data.length === 0 &&
    !externals.isLoading &&
    externals.data.length === 0

  const handleSwitchToSolely = (type: SmartSearchEntityType) => {
    setFilters({ ...filters, type })
  }

  if (showNoResults) {
    return <NoResults query={query} type={type} />
  }

  const items = [
    {
      type: SmartSearchEntityType.POSTS,
      queryResult: posts,
    },
    {
      type: SmartSearchEntityType.SPACES,
      queryResult: spaces,
    },
    {
      type: SmartSearchEntityType.MEMBERS,
      queryResult: members,
    },
    {
      type: SmartSearchEntityType.EXTERNALS,
      queryResult: externals,
    },
  ]

  return (
    <>
      {items.map(item =>
        !type || type === item.type ? (
          <SmartSearchResultsSection
            key={item.type}
            type={item.type}
            queryResult={item.queryResult}
            query={query}
            view={view}
            onSwitchToSolely={handleSwitchToSolely}
          />
        ) : null,
      )}
    </>
  )
}
